import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#11131C",
  fillRule: "evenodd",
  d: "M6.069 9.532c.688-2.7 3.131-4.703 6.047-4.703a6.25 6.25 0 0 1 6.246 6.247v.235A3.943 3.943 0 0 1 22 15.236a3.941 3.941 0 0 1-3.936 3.935h-2.366a.7.7 0 1 1 0-1.4h2.366a2.541 2.541 0 0 0 2.536-2.535 2.542 2.542 0 0 0-2.536-2.536h-.402a.7.7 0 0 1-.7-.7v-.924a4.851 4.851 0 0 0-4.846-4.847 4.848 4.848 0 0 0-4.776 4.057.7.7 0 0 1-.655.585 3.45 3.45 0 0 0-3.285 3.44 3.46 3.46 0 0 0 3.46 3.46h1.442a.7.7 0 1 1 0 1.4H6.86A4.86 4.86 0 0 1 2 14.311a4.847 4.847 0 0 1 4.069-4.78Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#11131C",
  fillRule: "evenodd",
  d: "M11.518 10.29a.7.7 0 0 1 .963 0l2.5 2.369a.7.7 0 1 1-.963 1.016l-1.318-1.25v5.006a.7.7 0 1 1-1.4 0v-5.005l-1.319 1.249a.7.7 0 1 1-.962-1.016l2.5-2.369Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=UploadIcon24.js.map